import { type MCPServerInfo } from '../../types';

const Context7Server: MCPServerInfo = {
  serverId: 'CONTEXT7',
  name: 'Context7',
  slug: 'context7',
  description: 'Context7 MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.context7.com/mcp'
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default Context7Server;
